import React from "react";
import { SmartTableNewInterface } from "soft_digi";
import { VEHICLES_URL } from "../../api/UserUrls";
import ImportExcelLayout from "../../components/site/ImportExcelLayout";

interface HeaderProps {
  loadTableData: () => void;
}

const ImportVehiclesReport: React.FC<HeaderProps> = ({ loadTableData }) => {
  const columns: SmartTableNewInterface.SmartTableNewColumnConfig[] = [
    { title: "S.NO", index: "s_no", type: "sno", width: "5" },
    { title: "Hub", index: "hub_name", width: "15" },
    { title: "Vendors", index: "vendor", width: "15" },
    { title: "Date", index: "date", width: "15" },
    {
      title: "Status",
      index: "status",
      width: "15",
      type: "tags",
      tags: [
        { value: 5, label: "Success", class: "is-success" },
        { value: 10, label: "Error", class: "is-danger" },
      ],
    },
    { title: "Msg", index: "msg", width: "15" },
  ];

  return (
    <ImportExcelLayout
      loadTableData={loadTableData}
      uploadUrl={VEHICLES_URL.IMPORT_EXCEL}
      templateHeaders={["S.NO", "HUB Name", "Customer", "date", "2 WL", "3 WL", "4 WL", "ZEN", "TATA_ACE"]}
      templateSampleData={[
        ["1", "Hub01", "Customer A", "01-01-2024", "10", "5", "3", "2", "1"],
        ["2", "Hub02", "Customer B", "02-01-2024", "8", "4", "2", "1", "0"],
      ]}
      templateFileName="vehicles_template.xlsx"
      description="Download the template, fill in your vehicle report data, and upload it below."
      columns={columns}
    />
  );
};

export default ImportVehiclesReport;
